import React from "react";

export let lang_en = {
        "id": "ID",
        "username": "Username",
        "password": "Password",
        "name": "Name",
        "first_name": "First Name",
        "second_name": "Second Name",
        "middle_name": "Middle Name",
        "last_name": "Last Name",
        "start_date": "Start Date",
        "end_date": "End Date",
        "start_time": "Start Time",
        "end_time": "End Time",
        "branches": "Branches",
        "service": "Service",
        "services": "Services",
        "package": "Package",
        "packages": "Packages",
        "price_list":"Price List",
        "default_price_list": "Default Price List",
        "prices": "Prices",
        "price": "Price",
        "total": "Total",
        "gender": "Gender",
        "birthday": "Birthday",
        "birth_date": "Birth Date",
        "branch": "Branch",
        "profile": "Profile",
        "logout": "LogOut",
        "signin": "Sign In",
        "signup": "Sign Up",
        "search": "Search",
        "clients": "Clients",
        "client": "Client",
        "memberships": "Memberships",
        "membership": "Membership",
        "employee": "Employee",
        "employees": "Employees",
        "actions": "Actions",
        "action": "Action",
        "mobile": "Mobile",
        "telephone": "Telephone",
        "social_id": "Soical ID",
        "nationality": "Nationality",
        "add": "Add",
        "remove": "Remove",
        "add_all": "Add All",
        "remove_all": "Remove All",
        "delete": "Delete",
        "save": "Save",
        "cancel": "Cancel",
        "close": "Close",
        "paid": "Paid",
        "balance": "Balance",
        "male": "Male",
        "female": "Female",
        "none": "None",
        "change_lang": "Change Language To Arabic",
        "yes": "Yes",
        "no": "No",
        "account": "Account",
        "status": "Status",
        "notes": "Notes",
        "duration": "Duration",
        "duration_days": "Duration (Days)",
        "date_created": "Date Created",
        "date_modified": "Date Modified",
        "approve": "Approve",
        "reject": "Reject",
        "sessions": "Sessions",
        "address": "Address",
        "coordinates": "Coordinates",
        "timezone": "Timezone",
        "tax": "Tax",
        "discount": "Discount",
        "amount": "Amount",
        "passport_number": "Passport Number",
        "email": "E-mail",
        "is_active": "Is Active",
        "Disactive": "Disactive",
        "country": "Country",
        "currency_symbol": "Currency Symbol",
        "emergency_contact_name": "Emergency Contact Name",
        "emergency_contact_telephone": "Emergency Contact Telephone",
        "request_no": "Request No",
        "feedback_by": "Feedback By",
        "feedback_date": "Feedback Date",
        "other": "Other",
        "cash": "Cash",
        "debit": "Debit",
        "credit": "Credit",
        "pay": "Pay",
        "refund": "Refund",
        "back": "Back",
        "for": "For",
        "males": "Males",
        "females": "Females",
        "offers": "Offers",
        "type": "Type",
        "description": "Description",
        "equipment": "Equipment",
        "qty": "Quantity",
        "increase": "Increase",
        "decrease": "Decrease",
        "received": "Received",
        "delivered": "Delivered",
        "total_qty": "Total Qty",
        "available_qty": "Available Quantity",
        "rented_qty": "Rented Qty",
        "area":"Area",
        "city":"City",
        "locations": "Locations",
        "location": "Location",
        "address_line_one" : "Address line one",
        "address_line_two" : "Address line two",
        "address_line_three" : "Address line three",
        "map_location": "Map Location",
        "staff": "Staff",
        "change_photo": "Change Photo",
        "role": "Role",
        "permission_group": "Permission Group",
        "change_password": "Change Password",
        "assigned_to": "Assigned To",
        "all_locations": "All Locations",
        "details": "Details",
        "information": "Information",
        "setting": "Setting",
        "available_at": "Available at",
        "show": "Show",
        "cancellation": "Cancellation",
        "freezes": "Freezes",
        "payments": "Payments",
        "cancellation_date": "Cancellation Date",
        "title": "Title",
        "date": "Date",
        "expenses": "Expenses",
        "expense": "Expense",
        "ex_number": "Expense number",
        "ex_date": "Expense Date",
        "add_expense": "Add Expense",
        "edit_expense": "Edit Expense",
        "view_expense": "View Expense",
        "expense_category": "Expense Category",
        "add_expense_category": "Add Expense Category",
        "edit_expense_category": "Edit Expense Category",
        "open": "Open",
        "payment_information": "Payment Information",
        "expense_information": "Expense Information",
        "expense_attachment": "Expense Attachment",
        "attachment": "Attachment",
        "add_attachment": "Add Attachment",
        "edit_attachment": "Edit Attachment",
        "cost": "Cost",
        "remove_file": "Remove File",
        "paid_by": "Paid By",
        "add_payment_method": "Add Payment Method",
        "edit_payment_method": "Edit Payment Method",
        "commission_type" : "Commission Type",
        "commission" : "Commission",
        "invoices" : "Invoices",
        "finance" : "Finance",
        "bank_transfers" : "Bank Transfers",
        "add_bank_transfer" : "Add Bank Transfer",
        "edit_bank_transfer" : "Edit Bank Transfer",
        "view_bank_transfer" : "View Bank Transfer",
        "bank_account" : "Bank Account",
        "add_bank_account" : "Add Bank Account",
        "edit_bank_account" : "Edit Bank Account",
        "view_bank_account" : "View Bank Account",
        "bank_transactions" : "Bank Transactions",
        "current_balance" : "Current Balance",
        "sender" : "Sender",
        "total_price": "Total Price",
        "access_permissions": "Access permissions",
        "reference": "Reference",
        "payment_date": "Payment Date",
        "payment_type": "Payment Type",
        "payment_method": "Payment Method",
        "add_payment": "New Payment",
        "add_refund": "New Refund",
        "number": "Number",
        "rents": "Rents",
        "add_rent": "New Rent",
        "edit_rent": "Edit Rent",
        "activate_rent" : "Activate Rent",
        "cancel_rent" : "Cancel Rent",
        "transfer_number" : "Transfer Number",
        "recipient" : "Recipient",
        "cash_transfer" : "Cash Transfer",
        "new_transfer" : "New Transfer",
        "sent_transfer" : "Sent Transfer",
        "received_transfer" : "Received Transfer",
        "transfer_form" : "Transfer Form",
        "cancel_transfer" : "Cancel Transfer",
        "confirm" : "Confirm",
        "cash_log" : "Cash Log",
        "sender_type" : "Sender Type",
        "recipient_type" : "Recipient Type",
        "sender_current_balance" : "Sender Current Balance",
        "recipient_current_balance" : "Recipient Current Balance",
        "pending_balance" : "Pending Balance",
        "free_balance" : "Free Balance",
        "available_balance" : "Available Balance",
        "target_staff" : "Target Staff",
        "add_cash_deposit" : "Add Cash Deposit",
        "add_funds" : "Add Funds",
        "add_withdraw" : "Add Withdraw",
        "received_as" : "Received As",
        "method" : "Method",
        "total_amount": "Total Amount",
        "from_cash_log": "From Cash Log",
        "bank_transfer_information": "Bank Transfer Information",
        "cheque": "Cheque",
        "bank_transfer" : "Bank Transfer",
        "paid_from" : "Paid From",
        "personal_money" : "Personal Money",
        "reimbursements" : "Reimbursements",
        "remaining" : "Remaining",
        "view_reimbursement" : "View Reimbursement",
        "attachments" : "Attachments",
        "add_class" : "Add Class",
        "edit_class" : "Edit Class",
        "classes" : "Classes",
        "schedule" : "Schedule",
        "limit" : "Limit",
        "duration_minutes" : "Duration (Minutes)",
        "saturday" : "Saturday",
        "sunday" : "Sunday",
        "monday" : "Monday",
        "tuesday" : "Tuesday",
        "wednesday" : "Wednesday",
        "thursday" : "Thursday",
        "friday" : "Friday",
        "from_date" : "From Date",
        "to_date" : "To Date",
        "add_time" : "Add Time",
        "days" : "Days",
        "vip_capacity" : "VIP Capacity",
        "capacity" : "Capacity",
        "room" : "Room",
        "edit_class_session" : "Edit Class Session",
        "add_class_session" : "Add Class Session",
        "class_sessions" : "Class Sessions",
        "is_locked" : "Is Locked",
        "registered_number" : "Registered Number",
        "rooms": "Rooms",
        "add_room" : "Add Room",
        "edit_room" : "Edit Room",
        "room_form" : "Room Form",
        "edit_attendee" : "Edit Attendee",
        "add_attendee" : "Add Attendee",
        "attendee_form" : "Attendee Form",
        "attendee": "Attendee",
        "attendees": "Attendees",
        "is_present": "Is present",
        "is_cancelled": "Is cancelled",
        "added_by": "Added By",
        "group_by_date": "Group By Date",
        "class_session" : "Class Session",
        "add_class_sessions" : "Add Class Session",
        "edit_class_sessions" : "Edit Class Session",
        "add_screen": "Add Screen",
        "edit_screen": "Edit Screen",
        "screen": "Screen",
        "screens": "Screens",
        "workout_screens": "Workout Screens",
        "workout": "Workout",
        "add_workout": "Add Workout",
        "edit_workout": "Edit Workout",
        "workout_form": "Workout Form",
        "content": "Content",
        "header": "Header",
        "display_screen": "Display Screen",
        "next": "Next",
        "duplicate_workout": "Duplicate Workout",
        "workouts": "Workouts",
        "whole_day": "Whole Day",
        "view_for": "View For",
        "add_section": "Add Section",
        "edit_section": "Edit Section",
        "workout_section_form": "Workout Section Form",
        "all_class_sessions": "All Class Sessions",
        "add_location": "Add Location",
        "edit_location": "Edit Location",
        "preferred_training_time": "Preferred Training Time",
        "invoice_date": "Invoice date",
        "dashboard": "Dashboard",
        "view": "View",
        "confirm_password": "Confirm Password",
        "company_name": "Company Name",
        "business_name": "Business Name",
        "personal_info": "Personal Info.",
        "entity_info": "Entity Info.",
        "user_info": "User Info.",
        "confirm_&_submit": "Confirm & Submit",
        "already_have_an_account?_sign_in": "Already have an account? Sign in",
        "submit": "Submit",
        "personal_information": "Personal Information",
        "user_information": "User Information",
        "membership_info": "Membership Information",
        "freezed": "Freezed",
        "transfer": "Transfer",
        "upgrade_duration": "Upgrade Duration",
        "alert": "Alert",
        "ok": "Ok",
        "change_invoice_date": "change Invoice dDate",
        "change_start_date": "Change start date",
        "sub_directory": "Sub Directory",
        "view_transfer_from": "View transfer from",
        "view_transfer_to": "View transfer to",
        "create": "Create",
        "import_data": "Import Data",
        "enter_entity": "Enter Entity",
        "model_&_file": "Model & File",
        "entity_pk": "Entity Pk",
        "models": "Models",
        "model": "Model",
        "view_info": "View Information",
        "write_entity_sub_director_to_confirm_the_process": "Write entity sub director to confirm the process",
        "file": "File",

        "empty_data_source_message": "No records to display",
        "table.delete_text": "Are you sure you want to delete this data ?",

};
